import {
  Team,
  UserPageDataTeamItem
} from '@maxpreps/apiserviceclients/apiModels';
import { getFavoriteTeam } from '@maxpreps/shared/functions/utils/teamUtils';
import {
  displayToastMessage,
  ToastMode
} from '../../corecomponents/Toastify/Toast';
import {
  postUserFavoriteTeam,
  postUserRemoveFavoriteTeam
} from '../ghost-apis/users-api';

export const addFavoriteTeamHelper = async (
  schoolId: string,
  allSeasonId: string,
  seasonName: string,
  userId?: string,
  token?: string
): Promise<UserPageDataTeamItem | undefined> => {
  if (!token || !userId) return;

  const [data, error] = await postUserFavoriteTeam(
    userId,
    {
      userId: userId,
      schoolId,
      allSeasonId,
      seasonName
    },
    token
  );

  if (error) {
    const errorMessage = await (error as any).getResponseErrors();
    displayToastMessage(errorMessage, ToastMode.Error);
  } else {
    displayToastMessage(
      `Success - you're following this team`,
      ToastMode.Success
    );
    return getFavoriteTeam(
      data as UserPageDataTeamItem[],
      {
        teamId: schoolId,
        allSeasonId,
        season: seasonName
      } as Team
    );
  }
};

export const removeFavoriteTeamHelper = async (
  favoriteId: string | number,
  userId?: string,
  token?: string
): Promise<void> => {
  if (!token || !userId) return;

  const [, error] = await postUserRemoveFavoriteTeam(userId, favoriteId, token);

  if (!error) {
    displayToastMessage(
      `Success - you're no longer following this team`,
      ToastMode.Success
    );
  } else {
    displayToastMessage(
      `Error - unable to unfollow this team`,
      ToastMode.Error
    );
  }
};
